var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.1,256c0,-137 -111.1,-248.1 -248.1,-248.1c-137,0 -248.1,111.1 -248.1,248.1c0,137 111.1,248.1 248.1,248.1c137,0 248.1,-111.1 248.1,-248.1z",
    fill: "#acdae2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.2,367.5c-1.4,-2 -4,-2.8 -6.3,-1.7c-24.6,11.6 -52.5,23.9 -58,25c-0.1,-0.1 -0.4,-0.3 -0.6,-0.7c-0.7,-1 -1.1,-2.3 -1.1,-4c0,-13.9 10.5,-56.2 31.2,-125.7c17.5,-58.4 19.5,-70.5 19.5,-74.5c0,-6.2 -2.4,-11.4 -6.9,-15.1c-4.3,-3.5 -10.2,-5.3 -17.7,-5.3c-12.5,0 -26.9,4.7 -44.1,14.5c-16.7,9.4 -35.4,25.4 -55.4,47.5c-1.6,1.7 -1.7,4.3 -0.4,6.2c1.3,1.9 3.8,2.6 6,1.8c7,-2.9 42.4,-17.4 47.6,-20.6c4.2,-2.6 7.9,-4 10.9,-4c0.1,0 0.2,0 0.3,0c0,0.2 0.1,0.5 0.1,0.9c0,3 -0.6,6.7 -1.9,10.7c-30.1,97.6 -44.8,157.5 -44.8,183c0,9 2.5,16.2 7.4,21.5c5,5.4 11.8,8.1 20.1,8.1c8.9,0 19.7,-3.7 33.1,-11.4c12.9,-7.4 32.7,-23.7 60.4,-49.7c1.7,-1.8 2,-4.5 0.6,-6.5zM322.2,84.6c-4.9,-5 -11.2,-7.6 -18.7,-7.6c-9.3,0 -17.5,3.7 -24.2,11c-6.6,7.2 -9.9,15.9 -9.9,26.1c0,8 2.5,14.7 7.3,19.8c4.9,5.2 11.1,7.8 18.5,7.8c9,0 17,-3.9 24,-11.6c6.9,-7.6 10.4,-16.4 10.4,-26.4c0,-7.7 -2.5,-14.1 -7.4,-19.1z",
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.77109fa88c4dea8c395194f141ce5ac2.svg";
export { ForwardRef as ReactComponent };